import classNames from 'classnames';
import type Immutable from 'immutable';
import {
  arrayOf,
  bool,
  func,
  number,
  oneOfType,
  shape,
  string,
} from 'prop-types';
import { Component } from 'react';
import { list } from 'react-immutable-proptypes';

import { Radio } from '@alkem/react-ui-inputs';

import { parseBoolean, parseNumber } from 'utils';

import './radio-input.scss';
import AuthFormTooltipError from './tooltip-error';

class AuthFormRadio extends Component<{
  formKey: string;
  options: { label: string; value: boolean | number }[];
  onChange: Function;
  value?: boolean | number;
  error?: boolean | Immutable.List<any>;
  errorMessage?: string;
  isBoolean?: boolean;
  isNumber?: boolean;
}> {
  static propTypes = {
    formKey: string,
    value: oneOfType([bool, number]),
    options: arrayOf(
      shape({ label: string, value: oneOfType([bool, number]) }),
    ),
    error: oneOfType([bool, list]),
    errorMessage: string,
    onChange: func.isRequired,
    isBoolean: bool,
    isNumber: bool,
  };

  state = { hasMouse: false };

  onMouseEnter = () => {
    this.setState({ hasMouse: true });
  };

  onMouseLeave = () => {
    this.setState({ hasMouse: false });
  };

  onChange = (event) => {
    const { onChange, formKey, isBoolean, isNumber } = this.props;
    let { value } = event.target;
    if (isBoolean) {
      value = parseBoolean(value);
    } else if (isNumber) {
      value = parseNumber(value);
    }
    onChange({ formKey, value });
  };

  render() {
    const { formKey, value, options, error, errorMessage } = this.props;
    const { hasMouse } = this.state;
    const showTooltip = error && hasMouse;
    return (
      <div
        className={classNames(
          'AuthFormRadio',
          error && 'AuthFormRadio--invalid',
        )}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        data-auth-form-error={`${!!error}`}
      >
        <Radio
          id={`auth-form-radio-${formKey}`}
          value={value}
          options={options}
          onChange={this.onChange}
        />
        {showTooltip && (
          <AuthFormTooltipError error={error}>
            {errorMessage}
          </AuthFormTooltipError>
        )}
      </div>
    );
  }
}

export default AuthFormRadio;
